import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import ReactHtmlParser from "react-html-parser";
import { Duration } from "luxon";
import { TimeContext, Countdown, Hero } from "Components";
import { Layout, BodySection } from "../Layout";

export const PreShow = ({ event }) => {
  const { time } = useContext(TimeContext);
  const themeContext = useContext(ThemeContext);

  const api = process.env.REACT_APP_FIRE_BASE_STORAGE_API;
  let headerLogo = `${api}/o/${event?.logos?.header?.path}?alt=media`;
  headerLogo = `/assets/${event?.logos?.header?.path}`;
  // const footerLogo = `${api}/o/${event?.logos?.footer?.path}?alt=media`;

  const timeToStart =
    time < event?.start &&
    Duration.fromMillis(event?.start - time).shiftTo(
      "days",
      "hours",
      "minutes",
      "seconds",
      "milliseconds"
    );

  const timer = {
    label: event?.preShow?.countdownLabel ?? "Show Starts In",
    days: timeToStart.days,
    hours: timeToStart.hours,
    minutes: timeToStart.minutes,
    seconds: timeToStart.seconds,
  };

  return (
    <Layout
      // header
      headerShowLogo={false}
      headerLogo={headerLogo}
      headerSecondaryText={event?.header}
      // hero
      heroContent={<Hero heroContent={<Countdown {...timer} />} />}
      heroPadding={themeContext.preShow?.heroPadding}
      // heading
      heading={event?.preShow?.heading}
      // main
      subHeading={event?.preShow?.subHeading}
      noPadding
      // add-ons
      noAddons
      // footer
      footerShowLogo
      footerLogo={headerLogo}
      footerShowText={false}
      footerPrivacyPolicy={event?.footer}
      footerLinkUrl="https://www.buyfordnow.com/"
    >
      {event?.preShow?.body ? (
        <BodySection>{ReactHtmlParser(event?.preShow?.body)}</BodySection>
      ) : undefined}
    </Layout>
  );
};
